import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  MarketingHeaderContainer,
  MarketingNavigationItemsContainer,
  MarketingDialogsContainer,
} from "@platform/features/marketing";
import { AppLayout } from "./AppLayout";

export type Props = {
  children?: React.ReactNode;
  title: string;
};

export function MarketingLayout({ children, title }: Props) {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <AppLayout
      header={
        <MarketingHeaderContainer>
          <MarketingNavigationItemsContainer />
        </MarketingHeaderContainer>
      }
      title={title}
    >
      {children ?? <Outlet />}
      <MarketingDialogsContainer />
    </AppLayout>
  );
}

export default MarketingLayout;
